export const formatShopifyImageURL = (imageUrl, boxSize) => {
  const getUrlImage = imageUrl.split('.');

  getUrlImage[getUrlImage.length - 2] += `_${boxSize}x${boxSize}`;

  return getUrlImage.join('.');
};
